import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

export default function AddressEmptyState() {
  return (
    <Grid2 item xs={12}>
      <Card variant="outlined" sx={{ borderRadius: 3 }}>
        <CardContent>
          <Typography color="text.secondary">
            Noch keine Adressen hinterlegt. Füge deine erste Adresse hinzu.
          </Typography>
        </CardContent>
      </Card>
    </Grid2>
  );
}
